export const ENDORSEMENTS_BANNER_KEY = 'endorsements_banner';
